import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

// GDPR Self-Assessment Questionnaire (Полная анкета самоаттестации)
export const GDPR_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'gov-responsibility',
    name_en: 'Governance and Responsibility',
    name_es: 'Gobernanza y Responsabilidad',
    name_ru: 'Управление и ответственность',
    questions: [
      {
        id: 'gov-1',
        blockId: 'gov-responsibility',
        text_en: 'Are legal grounds defined for all processing operations?',
        text_es: '¿Están definidos los fundamentos legales para todas las operaciones de procesamiento?',
        text_ru: 'Определены правовые основания для всех операций обработки?',
      },
      {
        id: 'gov-2',
        blockId: 'gov-responsibility',
        text_en: 'Is transparent information provided to data subjects?',
        text_es: '¿Se proporciona información transparente a los sujetos de datos?',
        text_ru: 'Предоставляется прозрачная информация субъектам данных?',
      },
      {
        id: 'gov-3',
        blockId: 'gov-responsibility',
        text_en: 'Is data accuracy and correctness ensured?',
        text_es: '¿Se garantiza la precisión y corrección de los datos?',
        text_ru: 'Обеспечена корректность и точность данных?',
      },
      {
        id: 'gov-4',
        blockId: 'gov-responsibility',
        text_en: 'Are data update procedures maintained?',
        text_es: '¿Se mantienen procedimientos de actualización de datos?',
        text_ru: 'Ведутся процедуры актуализации данных?',
      },
      {
        id: 'gov-5',
        blockId: 'gov-responsibility',
        text_en: 'Is data collection limited to minimally necessary data?',
        text_es: '¿La recopilación de datos se limita a datos mínimamente necesarios?',
        text_ru: 'Сбор данных ограничен минимально необходимыми?',
      },
      {
        id: 'gov-6',
        blockId: 'gov-responsibility',
        text_en: 'Are retention periods defined by data categories?',
        text_es: '¿Están definidos los períodos de retención por categorías de datos?',
        text_ru: 'Определены сроки хранения по категориям данных?',
      },
      {
        id: 'gov-7',
        blockId: 'gov-responsibility',
        text_en: 'Is deletion/anonymization implemented after retention periods?',
        text_es: '¿Se implementa eliminación/anonimización después de los períodos de retención?',
        text_ru: 'Реализовано удаление/анонимизация по истечении сроков?',
      },
      {
        id: 'gov-8',
        blockId: 'gov-responsibility',
        text_en: 'Has the need for DPO been assessed?',
        text_es: '¿Se ha evaluado la necesidad de un DPO?',
        text_ru: 'Проведена оценка необходимости DPO?',
      },
      {
        id: 'gov-9',
        blockId: 'gov-responsibility',
        text_en: 'Has a DPO been appointed (if required)?',
        text_es: '¿Se ha designado un DPO (si es requerido)?',
        text_ru: 'Назначен DPO?',
      },
      {
        id: 'gov-10',
        blockId: 'gov-responsibility',
        text_en: 'Is DPO contact information published?',
        text_es: '¿Se publica la información de contacto del DPO?',
        text_ru: 'Контактная информация опубликована?',
      },
    ],
  },
  {
    id: 'processing-register',
    name_en: 'Processing Activities Register (Article 30)',
    name_es: 'Registro de Actividades de Procesamiento (Artículo 30)',
    name_ru: 'Реестр операций обработки (ст. 30)',
    questions: [
      {
        id: 'proc-1',
        blockId: 'processing-register',
        text_en: 'Is a processing activities register maintained and kept up to date?',
        text_es: '¿Se mantiene y actualiza un registro de actividades de procesamiento?',
        text_ru: 'Оформлен и ведётся актуальный реестр обработки?',
      },
      {
        id: 'proc-2',
        blockId: 'processing-register',
        text_en: 'Does the register include: purposes, data categories, subjects, recipients, retention periods, security measures?',
        text_es: '¿El registro incluye: propósitos, categorías de datos, sujetos, destinatarios, períodos de retención, medidas de seguridad?',
        text_ru: 'Включены: цели, категории данных, субъекты, получатели, сроки хранения, меры безопасности?',
      },
    ],
  },
  {
    id: 'data-subject-rights',
    name_en: 'Data Subject Rights (Articles 12-23)',
    name_es: 'Derechos de los Sujetos de Datos (Artículos 12-23)',
    name_ru: 'Право субъектов данных (ст. 12–23)',
    questions: [
      {
        id: 'rights-1',
        blockId: 'data-subject-rights',
        text_en: 'Are procedures formalized for right of access?',
        text_es: '¿Están formalizados los procedimientos para el derecho de acceso?',
        text_ru: 'Формализованы процедуры права на доступ?',
      },
      {
        id: 'rights-2',
        blockId: 'data-subject-rights',
        text_en: 'Are procedures formalized for right to rectification?',
        text_es: '¿Están formalizados los procedimientos para el derecho de rectificación?',
        text_ru: 'Формализованы процедуры права на исправление?',
      },
      {
        id: 'rights-3',
        blockId: 'data-subject-rights',
        text_en: 'Are procedures formalized for right to erasure (right to be forgotten)?',
        text_es: '¿Están formalizados los procedimientos para el derecho al olvido?',
        text_ru: 'Формализованы процедуры права на удаление («право быть забытым»)?',
      },
      {
        id: 'rights-4',
        blockId: 'data-subject-rights',
        text_en: 'Are procedures formalized for right to restriction of processing?',
        text_es: '¿Están formalizados los procedimientos para el derecho a la limitación del procesamiento?',
        text_ru: 'Формализованы процедуры права на ограничение обработки?',
      },
      {
        id: 'rights-5',
        blockId: 'data-subject-rights',
        text_en: 'Are procedures formalized for right to data portability?',
        text_es: '¿Están formalizados los procedimientos para el derecho a la portabilidad de datos?',
        text_ru: 'Формализованы процедуры права на переносимость данных?',
      },
      {
        id: 'rights-6',
        blockId: 'data-subject-rights',
        text_en: 'Are procedures formalized for right to object?',
        text_es: '¿Están formalizados los procedimientos para el derecho de oposición?',
        text_ru: 'Формализованы процедуры права на возражение?',
      },
      {
        id: 'rights-7',
        blockId: 'data-subject-rights',
        text_en: 'Are procedures formalized for right not to be subject to automated decision-making?',
        text_es: '¿Están formalizados los procedimientos para el derecho a no ser objeto de decisiones automatizadas?',
        text_ru: 'Формализованы процедуры права не быть объектом автоматизированных решений?',
      },
      {
        id: 'rights-8',
        blockId: 'data-subject-rights',
        text_en: 'Are response SLAs defined (30 days)?',
        text_es: '¿Están definidos los SLA de respuesta (30 días)?',
        text_ru: 'Определены SLA ответа (30 дней)?',
      },
      {
        id: 'rights-9',
        blockId: 'data-subject-rights',
        text_en: 'Are responsible persons assigned for each right?',
        text_es: '¿Hay personas responsables asignadas para cada derecho?',
        text_ru: 'Назначены ответственные?',
      },
    ],
  },
  {
    id: 'consent-management',
    name_en: 'Consent Management (Article 7)',
    name_es: 'Gestión de Consentimiento (Artículo 7)',
    name_ru: 'Согласия на обработку (ст. 7)',
    questions: [
      {
        id: 'consent-1',
        blockId: 'consent-management',
        text_en: 'Are only valid consent forms used?',
        text_es: '¿Se utilizan solo formularios de consentimiento válidos?',
        text_ru: 'Используются только валидные формы согласия?',
      },
      {
        id: 'consent-2',
        blockId: 'consent-management',
        text_en: 'Is consent separated from other terms?',
        text_es: '¿El consentimiento está separado de otros términos?',
        text_ru: 'Согласие отделено от других условий?',
      },
      {
        id: 'consent-3',
        blockId: 'consent-management',
        text_en: 'Is consent documentation implemented?',
        text_es: '¿Está implementada la documentación del consentimiento?',
        text_ru: 'Реализовано документирование согласий?',
      },
      {
        id: 'consent-4',
        blockId: 'consent-management',
        text_en: 'Is consent withdrawal procedure implemented?',
        text_es: '¿Está implementado el procedimiento de retiro de consentimiento?',
        text_ru: 'Реализована процедура отзыва согласия?',
      },
    ],
  },
  {
    id: 'child-data-processing',
    name_en: 'Child Data Processing (Article 8)',
    name_es: 'Procesamiento de Datos de Menores (Artículo 8)',
    name_ru: 'Обработка данных детей (ст. 8)',
    questions: [
      {
        id: 'child-1',
        blockId: 'child-data-processing',
        text_en: 'Is age verification implemented (verifiable parental consent)?',
        text_es: '¿Está implementada la verificación de edad (consentimiento parental verificable)?',
        text_ru: 'Проверяется возраст (verifiable parental consent)?',
      },
      {
        id: 'child-2',
        blockId: 'child-data-processing',
        text_en: 'Are parental consent verification mechanisms implemented?',
        text_es: '¿Están implementados los mecanismos de verificación del consentimiento parental?',
        text_ru: 'Реализованы механизмы верификации согласия родителей?',
      },
    ],
  },
  {
    id: 'data-transfer',
    name_en: 'Third-Party Data Transfer and International Transfer (Articles 28, 44-49)',
    name_es: 'Transferencia de Datos a Terceros y Transferencia Internacional (Artículos 28, 44-49)',
    name_ru: 'Передача данных третьим сторонам и международный трансфер (ст. 28, 44–49)',
    questions: [
      {
        id: 'transfer-1',
        blockId: 'data-transfer',
        text_en: 'Are Data Processing Agreements (DPA) concluded?',
        text_es: '¿Se han concluido Acuerdos de Procesamiento de Datos (DPA)?',
        text_ru: 'Заключены Data Processing Agreements (DPA)?',
      },
      {
        id: 'transfer-2',
        blockId: 'data-transfer',
        text_en: 'Has supplier risk assessment been conducted?',
        text_es: '¿Se ha realizado una evaluación de riesgos de proveedores?',
        text_ru: 'Проведена оценка рисков поставщиков?',
      },
      {
        id: 'transfer-3',
        blockId: 'data-transfer',
        text_en: 'Is international transfer regulated by SCC/Adequacy?',
        text_es: '¿Está regulada la transferencia internacional por SCC/Adecuación?',
        text_ru: 'Международный трансфер регулируется SCC/Адекватностью?',
      },
      {
        id: 'transfer-4',
        blockId: 'data-transfer',
        text_en: 'Do suppliers comply with technical and organizational measures?',
        text_es: '¿Los proveedores cumplen con las medidas técnicas y organizativas?',
        text_ru: 'Поставщики соответствуют техническим и организационным мерам?',
      },
    ],
  },
  {
    id: 'dpia',
    name_en: 'DPIA - Impact Assessment (Article 35)',
    name_es: 'DPIA - Evaluación de Impacto (Artículo 35)',
    name_ru: 'DPIA — Оценка воздействия (ст. 35)',
    questions: [
      {
        id: 'dpia-1',
        blockId: 'dpia',
        text_en: 'Is DPIA conducted for large-scale processing?',
        text_es: '¿Se realiza DPIA para procesamiento a gran escala?',
        text_ru: 'Проводится ли DPIA в случаях масштабная обработка?',
      },
      {
        id: 'dpia-2',
        blockId: 'dpia',
        text_en: 'Is DPIA conducted for behavioral monitoring?',
        text_es: '¿Se realiza DPIA para monitoreo de comportamiento?',
        text_ru: 'Проводится ли DPIA в случаях мониторинг поведения?',
      },
      {
        id: 'dpia-3',
        blockId: 'dpia',
        text_en: 'Is DPIA conducted for processing sensitive personal data?',
        text_es: '¿Se realiza DPIA para procesamiento de datos personales sensibles?',
        text_ru: 'Проводится ли DPIA в случаях работа с чувствительными персональными данными?',
      },
      {
        id: 'dpia-4',
        blockId: 'dpia',
        text_en: 'Is DPIA conducted for new technologies?',
        text_es: '¿Se realiza DPIA para nuevas tecnologías?',
        text_ru: 'Проводится ли DPIA в случаях новые технологии?',
      },
    ],
  },
  {
    id: 'incidents',
    name_en: 'Security Incidents and Data Breaches (Articles 33-34)',
    name_es: 'Incidentes de Seguridad y Filtraciones de Datos (Artículos 33-34)',
    name_ru: 'Инциденты безопасности и утечки данных (ст. 33–34)',
    questions: [
      {
        id: 'incident-1',
        blockId: 'incidents',
        text_en: 'Is there a formal incident response policy?',
        text_es: '¿Existe una política formal de respuesta a incidentes?',
        text_ru: 'Наличие формальной политики реагирования?',
      },
      {
        id: 'incident-2',
        blockId: 'incidents',
        text_en: 'Can AEPD be notified within 72 hours?',
        text_es: '¿Se puede notificar a la AEPD en un plazo de 72 horas?',
        text_ru: 'Способность уведомить AEPD в течение 72 часов?',
      },
      {
        id: 'incident-3',
        blockId: 'incidents',
        text_en: 'Is there a procedure for notifying data subjects?',
        text_es: '¿Existe un procedimiento para notificar a los sujetos de datos?',
        text_ru: 'Процедура уведомления субъектов данных?',
      },
      {
        id: 'incident-4',
        blockId: 'incidents',
        text_en: 'Are incidents registered and analyzed?',
        text_es: '¿Se registran y analizan los incidentes?',
        text_ru: 'Регистрация и анализ инцидентов?',
      },
    ],
  },
  {
    id: 'security-measures',
    name_en: 'Technical and Organizational Security Measures (Article 32)',
    name_es: 'Medidas Técnicas y Organizativas de Seguridad (Artículo 32)',
    name_ru: 'Технические и организационные меры безопасности (ст. 32)',
    questions: [
      {
        id: 'security-1',
        blockId: 'security-measures',
        text_en: 'Is data encryption implemented?',
        text_es: '¿Está implementado el cifrado de datos?',
        text_ru: 'Шифрование данных?',
      },
      {
        id: 'security-2',
        blockId: 'security-measures',
        text_en: 'Is pseudonymization implemented?',
        text_es: '¿Está implementada la seudonimización?',
        text_ru: 'Псевдонимизация?',
      },
      {
        id: 'security-3',
        blockId: 'security-measures',
        text_en: 'Is access control (RBAC) implemented?',
        text_es: '¿Está implementado el control de acceso (RBAC)?',
        text_ru: 'Управление доступом (RBAC)?',
      },
      {
        id: 'security-4',
        blockId: 'security-measures',
        text_en: 'Is regular testing of recovery plans conducted?',
        text_es: '¿Se realiza prueba regular de los planes de recuperación?',
        text_ru: 'Регулярное тестирование планов восстановления?',
      },
      {
        id: 'security-5',
        blockId: 'security-measures',
        text_en: 'Is monitoring and logging implemented?',
        text_es: '¿Están implementados el monitoreo y registro?',
        text_ru: 'Мониторинг и логирование?',
      },
    ],
  },
  {
    id: 'privacy-by-design',
    name_en: 'Privacy by Default and by Design (Article 25)',
    name_es: 'Privacidad por Defecto y por Diseño (Artículo 25)',
    name_ru: 'Приватность по умолчанию и по проекту (ст. 25)',
    questions: [
      {
        id: 'privacy-1',
        blockId: 'privacy-by-design',
        text_en: 'Are privacy-by-design and privacy-by-default implemented?',
        text_es: '¿Están implementados privacy-by-design y privacy-by-default?',
        text_ru: 'Реализованы privacy-by-design и privacy-by-default?',
      },
      {
        id: 'privacy-2',
        blockId: 'privacy-by-design',
        text_en: 'Do development and implementation processes consider GDPR?',
        text_es: '¿Los procesos de desarrollo e implementación consideran GDPR?',
        text_ru: 'Процессы разработки и внедрения учитывают GDPR?',
      },
    ],
  },
  {
    id: 'outsourcing',
    name_en: 'Outsourcing and External Suppliers (Article 28)',
    name_es: 'Subcontratación y Proveedores Externos (Artículo 28)',
    name_ru: 'Аутсорсинг и внешние поставщики (ст. 28)',
    questions: [
      {
        id: 'outsource-1',
        blockId: 'outsourcing',
        text_en: 'Is supplier assessment conducted?',
        text_es: '¿Se realiza evaluación de proveedores?',
        text_ru: 'Оценка поставщиков?',
      },
      {
        id: 'outsource-2',
        blockId: 'outsourcing',
        text_en: 'Are DPAs in place?',
        text_es: '¿Existen DPAs?',
        text_ru: 'DPA?',
      },
      {
        id: 'outsource-3',
        blockId: 'outsourcing',
        text_en: 'Is supplier control and audit implemented?',
        text_es: '¿Está implementado el control y auditoría de proveedores?',
        text_ru: 'Контроль и аудит поставщиков?',
      },
    ],
  },
  {
    id: 'documentation',
    name_en: 'Compliance Documentation (Articles 24, 5(2))',
    name_es: 'Documentación de Cumplimiento (Artículos 24, 5(2))',
    name_ru: 'Документирование соответствия (ст. 24, 5(2))',
    questions: [
      {
        id: 'doc-1',
        blockId: 'documentation',
        text_en: 'Are responsible persons assigned?',
        text_es: '¿Están asignadas personas responsables?',
        text_ru: 'Назначены ответственные?',
      },
      {
        id: 'doc-2',
        blockId: 'documentation',
        text_en: 'Is documentation kept up to date?',
        text_es: '¿Se mantiene actualizada la documentación?',
        text_ru: 'Документация обновляется?',
      },
      {
        id: 'doc-3',
        blockId: 'documentation',
        text_en: 'Is regular GDPR audit conducted?',
        text_es: '¿Se realiza auditoría regular de GDPR?',
        text_ru: 'Проводится регулярный аудит GDPR?',
      },
    ],
  },
];

// GDPR Required Documents Checklist (Полный перечень необходимых документов)
export const GDPR_DOCUMENTS_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'doc-org',
    name_en: 'Organizational Documents',
    name_es: 'Documentos Organizacionales',
    name_ru: 'Организационные документы',
    questions: [
      {
        id: 'doc-org-1',
        blockId: 'doc-org',
        text_en: 'Data Protection Policy',
        text_es: 'Política de Protección de Datos',
        text_ru: 'Политика защиты персональных данных (Data Protection Policy)',
      },
      {
        id: 'doc-org-2',
        blockId: 'doc-org',
        text_en: 'Privacy Notice',
        text_es: 'Aviso de Privacidad',
        text_ru: 'Политика конфиденциальности (Privacy Notice)',
      },
      {
        id: 'doc-org-3',
        blockId: 'doc-org',
        text_en: 'DSAR Policy (Data Subject Access Requests)',
        text_es: 'Política DSAR (Solicitudes de Acceso de Sujetos de Datos)',
        text_ru: 'Политика обработки запросов субъектов данных (DSAR Policy)',
      },
      {
        id: 'doc-org-4',
        blockId: 'doc-org',
        text_en: 'Data Retention and Deletion Policy',
        text_es: 'Política de Retención y Eliminación de Datos',
        text_ru: 'Политика хранения и удаления данных (Retention Policy)',
      },
      {
        id: 'doc-org-5',
        blockId: 'doc-org',
        text_en: 'Processing Activities Register (RoPA - Article 30)',
        text_es: 'Registro de Actividades de Procesamiento (RoPA - Artículo 30)',
        text_ru: 'Реестр операций обработки (RoPA — ст. 30)',
      },
      {
        id: 'doc-org-6',
        blockId: 'doc-org',
        text_en: 'Consent Management Policy',
        text_es: 'Política de Gestión de Consentimiento',
        text_ru: 'Политика управления согласиями',
      },
      {
        id: 'doc-org-7',
        blockId: 'doc-org',
        text_en: 'Incident Response and Data Breach Policy',
        text_es: 'Política de Respuesta a Incidentes y Filtraciones de Datos',
        text_ru: 'Политика реагирования на инциденты и утечки данных',
      },
      {
        id: 'doc-org-8',
        blockId: 'doc-org',
        text_en: 'Vendor & DPA Management Policy',
        text_es: 'Política de Gestión de Proveedores y DPA',
        text_ru: 'Политика управления поставщиками (Vendor & DPA Management Policy)',
      },
      {
        id: 'doc-org-9',
        blockId: 'doc-org',
        text_en: 'Evaluation of Legal Grounds (Claims & Legal Bases Register)',
        text_es: 'Evaluación de Fundamentos Legales (Registro de Reclamaciones y Bases Legales)',
        text_ru: 'Evaluation of Legal Grounds (Claims & Legal Bases Register)',
      },
    ],
  },
  {
    id: 'doc-security',
    name_en: 'Security Documents',
    name_es: 'Documentos de Seguridad',
    name_ru: 'Документы безопасности',
    questions: [
      {
        id: 'doc-sec-1',
        blockId: 'doc-security',
        text_en: 'Access Management Policy',
        text_es: 'Política de Gestión de Acceso',
        text_ru: 'Политика управления доступом',
      },
      {
        id: 'doc-sec-2',
        blockId: 'doc-security',
        text_en: 'Data Classification Policy',
        text_es: 'Política de Clasificación de Datos',
        text_ru: 'Политика классификации данных',
      },
      {
        id: 'doc-sec-3',
        blockId: 'doc-security',
        text_en: 'Encryption Policy',
        text_es: 'Política de Cifrado',
        text_ru: 'Политика шифрования',
      },
      {
        id: 'doc-sec-4',
        blockId: 'doc-security',
        text_en: 'Backup Policy',
        text_es: 'Política de Respaldo',
        text_ru: 'Политика резервного копирования',
      },
      {
        id: 'doc-sec-5',
        blockId: 'doc-security',
        text_en: 'Secure SDLC + Privacy by Design Policy',
        text_es: 'Política de SDLC Seguro + Privacidad por Diseño',
        text_ru: 'Политика безопасной разработки (Secure SDLC + Privacy by Design)',
      },
    ],
  },
  {
    id: 'doc-risk',
    name_en: 'Risk Management Documents',
    name_es: 'Documentos de Gestión de Riesgos',
    name_ru: 'Документы по управлению рисками',
    questions: [
      {
        id: 'doc-risk-1',
        blockId: 'doc-risk',
        text_en: 'DPIA (Data Protection Impact Assessment) template',
        text_es: 'Plantilla DPIA (Evaluación de Impacto en la Protección de Datos)',
        text_ru: 'DPIA (Data Protection Impact Assessment) template',
      },
      {
        id: 'doc-risk-2',
        blockId: 'doc-risk',
        text_en: 'DPIA Registration',
        text_es: 'Registro DPIA',
        text_ru: 'Регистрация DPIA',
      },
      {
        id: 'doc-risk-3',
        blockId: 'doc-risk',
        text_en: 'Supplier Security Assessment',
        text_es: 'Evaluación de Seguridad de Proveedores',
        text_ru: 'Оценка безопасности поставщиков',
      },
      {
        id: 'doc-risk-4',
        blockId: 'doc-risk',
        text_en: 'GDPR Risk Registers',
        text_es: 'Registros de Riesgos GDPR',
        text_ru: 'Регистры рисков GDPR',
      },
    ],
  },
  {
    id: 'doc-incidents',
    name_en: 'Incident Documents',
    name_es: 'Documentos de Incidentes',
    name_ru: 'Документы по инцидентам',
    questions: [
      {
        id: 'doc-incident-1',
        blockId: 'doc-incidents',
        text_en: 'Incident Registration Form',
        text_es: 'Formulario de Registro de Incidentes',
        text_ru: 'Форма регистрации инцидента',
      },
      {
        id: 'doc-incident-2',
        blockId: 'doc-incidents',
        text_en: 'AEPD Notification Procedure',
        text_es: 'Procedimiento de Notificación AEPD',
        text_ru: 'Процедура уведомления AEPD',
      },
      {
        id: 'doc-incident-3',
        blockId: 'doc-incidents',
        text_en: 'Data Subject Notification Procedure',
        text_es: 'Procedimiento de Notificación a Sujetos de Datos',
        text_ru: 'Процедура уведомления субъектов',
      },
    ],
  },
  {
    id: 'doc-contracts',
    name_en: 'Contract Documents',
    name_es: 'Documentos Contractuales',
    name_ru: 'Договорные документы',
    questions: [
      {
        id: 'doc-contract-1',
        blockId: 'doc-contracts',
        text_en: 'Data Processing Agreement (DPA)',
        text_es: 'Acuerdo de Procesamiento de Datos (DPA)',
        text_ru: 'Data Processing Agreement (DPA)',
      },
      {
        id: 'doc-contract-2',
        blockId: 'doc-contracts',
        text_en: 'Standard Contractual Clauses (SCC) - if transfer outside EU',
        text_es: 'Cláusulas Contractuales Estándar (SCC) - si hay transferencia fuera de la UE',
        text_ru: 'Standard Contractual Clauses (SCC) — если есть трансфер за пределы ЕС',
      },
      {
        id: 'doc-contract-3',
        blockId: 'doc-contracts',
        text_en: 'Privacy Terms for Customers',
        text_es: 'Términos de Privacidad para Clientes',
        text_ru: 'Privacy Terms для клиентов',
      },
    ],
  },
];

// GDPR Required Processes Checklist (Перечень всех процессов)
export const GDPR_PROCESSES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'proc-legal',
    name_en: 'Legal Grounds Management',
    name_es: 'Gestión de Fundamentos Legales',
    name_ru: 'Управление правовыми основаниями',
    questions: [
      {
        id: 'proc-legal-1',
        blockId: 'proc-legal',
        text_en: 'Documentation of legal grounds',
        text_es: 'Documentación de fundamentos legales',
        text_ru: 'Документирование правового основания',
      },
      {
        id: 'proc-legal-2',
        blockId: 'proc-legal',
        text_en: 'Review of grounds when purposes change',
        text_es: 'Revisión de fundamentos cuando cambian los propósitos',
        text_ru: 'Пересмотр оснований при изменении целей',
      },
    ],
  },
  {
    id: 'proc-lifecycle',
    name_en: 'Data Lifecycle Management',
    name_es: 'Gestión del Ciclo de Vida de los Datos',
    name_ru: 'Управление жизненным циклом данных',
    questions: [
      {
        id: 'proc-lifecycle-1',
        blockId: 'proc-lifecycle',
        text_en: 'Collection process',
        text_es: 'Proceso de recopilación',
        text_ru: 'Сбор',
      },
      {
        id: 'proc-lifecycle-2',
        blockId: 'proc-lifecycle',
        text_en: 'Storage process',
        text_es: 'Proceso de almacenamiento',
        text_ru: 'Хранение',
      },
      {
        id: 'proc-lifecycle-3',
        blockId: 'proc-lifecycle',
        text_en: 'Usage process',
        text_es: 'Proceso de uso',
        text_ru: 'Использование',
      },
      {
        id: 'proc-lifecycle-4',
        blockId: 'proc-lifecycle',
        text_en: 'Transfer process',
        text_es: 'Proceso de transferencia',
        text_ru: 'Передача',
      },
      {
        id: 'proc-lifecycle-5',
        blockId: 'proc-lifecycle',
        text_en: 'Archiving process',
        text_es: 'Proceso de archivado',
        text_ru: 'Архивирование',
      },
      {
        id: 'proc-lifecycle-6',
        blockId: 'proc-lifecycle',
        text_en: 'Deletion/anonymization process',
        text_es: 'Proceso de eliminación/anonimización',
        text_ru: 'Удаление/анонимизация',
      },
    ],
  },
  {
    id: 'proc-dsar',
    name_en: 'DSAR Processing',
    name_es: 'Procesamiento DSAR',
    name_ru: 'Обработка запросов субъектов данных (DSAR)',
    questions: [
      {
        id: 'proc-dsar-1',
        blockId: 'proc-dsar',
        text_en: 'Request reception',
        text_es: 'Recepción de solicitudes',
        text_ru: 'Принятие запроса',
      },
      {
        id: 'proc-dsar-2',
        blockId: 'proc-dsar',
        text_en: 'Identity verification',
        text_es: 'Verificación de identidad',
        text_ru: 'Верификация личности',
      },
      {
        id: 'proc-dsar-3',
        blockId: 'proc-dsar',
        text_en: 'Request processing within 30 days',
        text_es: 'Procesamiento de solicitudes dentro de 30 días',
        text_ru: 'Обработка запроса в течение 30 дней',
      },
      {
        id: 'proc-dsar-4',
        blockId: 'proc-dsar',
        text_en: 'Documentation',
        text_es: 'Documentación',
        text_ru: 'Документирование',
      },
    ],
  },
  {
    id: 'proc-consent',
    name_en: 'Consent Management',
    name_es: 'Gestión de Consentimiento',
    name_ru: 'Управление согласиями',
    questions: [
      {
        id: 'proc-consent-1',
        blockId: 'proc-consent',
        text_en: 'Consent acquisition process',
        text_es: 'Proceso de obtención de consentimiento',
        text_ru: 'Получение согласия',
      },
      {
        id: 'proc-consent-2',
        blockId: 'proc-consent',
        text_en: 'Consent storage process',
        text_es: 'Proceso de almacenamiento de consentimiento',
        text_ru: 'Хранение согласия',
      },
      {
        id: 'proc-consent-3',
        blockId: 'proc-consent',
        text_en: 'Consent withdrawal process',
        text_es: 'Proceso de retiro de consentimiento',
        text_ru: 'Отзыв согласия',
      },
      {
        id: 'proc-consent-4',
        blockId: 'proc-consent',
        text_en: 'Consent audit process',
        text_es: 'Proceso de auditoría de consentimiento',
        text_ru: 'Аудит согласий',
      },
    ],
  },
  {
    id: 'proc-incident',
    name_en: 'Incident and Data Breach Response',
    name_es: 'Respuesta a Incidentes y Filtraciones de Datos',
    name_ru: 'Реагирование на инциденты и утечки данных',
    questions: [
      {
        id: 'proc-incident-1',
        blockId: 'proc-incident',
        text_en: 'Incident detection process',
        text_es: 'Proceso de detección de incidentes',
        text_ru: 'Выявление',
      },
      {
        id: 'proc-incident-2',
        blockId: 'proc-incident',
        text_en: 'Incident classification process',
        text_es: 'Proceso de clasificación de incidentes',
        text_ru: 'Классификация',
      },
      {
        id: 'proc-incident-3',
        blockId: 'proc-incident',
        text_en: 'Regulator notification process',
        text_es: 'Proceso de notificación al regulador',
        text_ru: 'Уведомление регулятора',
      },
      {
        id: 'proc-incident-4',
        blockId: 'proc-incident',
        text_en: 'Data subject notification process (if required)',
        text_es: 'Proceso de notificación a sujetos de datos (si es requerido)',
        text_ru: 'Уведомление субъекта (если требуется)',
      },
      {
        id: 'proc-incident-5',
        blockId: 'proc-incident',
        text_en: 'Prevention of recurrence process',
        text_es: 'Proceso de prevención de recurrencia',
        text_ru: 'Предотвращение повторения',
      },
    ],
  },
  {
    id: 'proc-supplier',
    name_en: 'Supplier Management and Data Transfer',
    name_es: 'Gestión de Proveedores y Transferencia de Datos',
    name_ru: 'Управление поставщиками и передача данных',
    questions: [
      {
        id: 'proc-supplier-1',
        blockId: 'proc-supplier',
        text_en: 'Supplier due diligence process',
        text_es: 'Proceso de diligencia debida de proveedores',
        text_ru: 'Due diligence поставщиков',
      },
      {
        id: 'proc-supplier-2',
        blockId: 'proc-supplier',
        text_en: 'DPA management process',
        text_es: 'Proceso de gestión de DPA',
        text_ru: 'DPA',
      },
      {
        id: 'proc-supplier-3',
        blockId: 'proc-supplier',
        text_en: 'Supplier monitoring process',
        text_es: 'Proceso de monitoreo de proveedores',
        text_ru: 'Мониторинг',
      },
      {
        id: 'proc-supplier-4',
        blockId: 'proc-supplier',
        text_en: 'Supplier audit process',
        text_es: 'Proceso de auditoría de proveedores',
        text_ru: 'Аудит',
      },
      {
        id: 'proc-supplier-5',
        blockId: 'proc-supplier',
        text_en: 'International transfer legality assessment process',
        text_es: 'Proceso de evaluación de legalidad de transferencia internacional',
        text_ru: 'Оценка законности трансфера вне ЕС',
      },
    ],
  },
  {
    id: 'proc-dpia',
    name_en: 'DPIA (Impact Assessment)',
    name_es: 'DPIA (Evaluación de Impacto)',
    name_ru: 'DPIA (оценка воздействия)',
    questions: [
      {
        id: 'proc-dpia-1',
        blockId: 'proc-dpia',
        text_en: 'Necessity determination process',
        text_es: 'Proceso de determinación de necesidad',
        text_ru: 'Определение необходимости',
      },
      {
        id: 'proc-dpia-2',
        blockId: 'proc-dpia',
        text_en: 'DPIA execution process',
        text_es: 'Proceso de ejecución de DPIA',
        text_ru: 'Выполнение DPIA',
      },
      {
        id: 'proc-dpia-3',
        blockId: 'proc-dpia',
        text_en: 'DPO consultation process',
        text_es: 'Proceso de consulta con DPO',
        text_ru: 'Согласование с DPO',
      },
      {
        id: 'proc-dpia-4',
        blockId: 'proc-dpia',
        text_en: 'Risk mitigation measures process',
        text_es: 'Proceso de medidas de mitigación de riesgos',
        text_ru: 'Прием мер по снижению рисков',
      },
    ],
  },
  {
    id: 'proc-access',
    name_en: 'Access Management',
    name_es: 'Gestión de Acceso',
    name_ru: 'Управление доступом',
    questions: [
      {
        id: 'proc-access-1',
        blockId: 'proc-access',
        text_en: 'Minimum necessary role assignment process',
        text_es: 'Proceso de asignación de roles mínimamente necesarios',
        text_ru: 'Назначение минимально необходимых ролей',
      },
      {
        id: 'proc-access-2',
        blockId: 'proc-access',
        text_en: 'Access removal upon termination process',
        text_es: 'Proceso de eliminación de acceso al término',
        text_ru: 'Удаление доступа при увольнении',
      },
      {
        id: 'proc-access-3',
        blockId: 'proc-access',
        text_en: 'Regular access review process',
        text_es: 'Proceso de revisión regular de acceso',
        text_ru: 'Регулярная ревизия',
      },
    ],
  },
  {
    id: 'proc-privacy-design',
    name_en: 'Privacy by Design / by Default',
    name_es: 'Privacidad por Diseño / por Defecto',
    name_ru: 'Privacy by Design / by Default',
    questions: [
      {
        id: 'proc-privacy-1',
        blockId: 'proc-privacy-design',
        text_en: 'DPO participation in development process',
        text_es: 'Proceso de participación de DPO en desarrollo',
        text_ru: 'Участие DPO в разработке',
      },
      {
        id: 'proc-privacy-2',
        blockId: 'proc-privacy-design',
        text_en: 'Data analysis and minimization process',
        text_es: 'Proceso de análisis y minimización de datos',
        text_ru: 'Анализ данных и минимизация',
      },
      {
        id: 'proc-privacy-3',
        blockId: 'proc-privacy-design',
        text_en: 'Default settings verification process',
        text_es: 'Proceso de verificación de configuraciones por defecto',
        text_ru: 'Проверка настроек по умолчанию',
      },
    ],
  },
  {
    id: 'proc-training',
    name_en: 'Staff Training',
    name_es: 'Capacitación del Personal',
    name_ru: 'Обучение персонала',
    questions: [
      {
        id: 'proc-training-1',
        blockId: 'proc-training',
        text_en: 'Onboarding training process',
        text_es: 'Proceso de capacitación de incorporación',
        text_ru: 'Вводный тренинг',
      },
      {
        id: 'proc-training-2',
        blockId: 'proc-training',
        text_en: 'Annual training process',
        text_es: 'Proceso de capacitación anual',
        text_ru: 'Ежегодное обучение',
      },
      {
        id: 'proc-training-3',
        blockId: 'proc-training',
        text_en: 'Development and support departments training process',
        text_es: 'Proceso de capacitación para departamentos de desarrollo y soporte',
        text_ru: 'Обучение отделов разработки и поддержки',
      },
    ],
  },
  {
    id: 'proc-audit',
    name_en: 'Internal GDPR Audit',
    name_es: 'Auditoría Interna GDPR',
    name_ru: 'Внутренний аудит GDPR',
    questions: [
      {
        id: 'proc-audit-1',
        blockId: 'proc-audit',
        text_en: 'Annual process review process',
        text_es: 'Proceso de revisión anual de procesos',
        text_ru: 'Ежегодная проверка процессов',
      },
      {
        id: 'proc-audit-2',
        blockId: 'proc-audit',
        text_en: 'Corrective actions process',
        text_es: 'Proceso de acciones correctivas',
        text_ru: 'Корректирующие действия',
      },
    ],
  },
];

// GDPR Roles & Departments Checklist (Перечень ролей и подразделений)
export const GDPR_ROLES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'roles-key',
    name_en: 'Key Roles',
    name_es: 'Roles Clave',
    name_ru: 'Ключевые роли',
    questions: [
      {
        id: 'roles-key-1',
        blockId: 'roles-key',
        text_en: 'DPO (Data Protection Officer) - appointed if required',
        text_es: 'DPO (Responsable de Protección de Datos) - designado si es requerido',
        text_ru: 'DPO (Data Protection Officer) — назначен при необходимости',
      },
      {
        id: 'roles-key-2',
        blockId: 'roles-key',
        text_en: 'Data Controller (usually company management)',
        text_es: 'Responsable del Tratamiento (generalmente la dirección de la empresa)',
        text_ru: 'Data Controller (владелец данных) — обычно руководство компании',
      },
      {
        id: 'roles-key-3',
        blockId: 'roles-key',
        text_en: 'Data Processor (suppliers, contractors, hosting providers)',
        text_es: 'Encargado del Tratamiento (proveedores, contratistas, proveedores de hosting)',
        text_ru: 'Data Processor (обработчики данных) — поставщики, подрядчики, хостинги',
      },
    ],
  },
  {
    id: 'dept-it',
    name_en: 'IT / DevOps Department',
    name_es: 'Departamento IT / DevOps',
    name_ru: 'IT / DevOps подразделение',
    questions: [
      {
        id: 'dept-it-1',
        blockId: 'dept-it',
        text_en: 'Access control',
        text_es: 'Control de acceso',
        text_ru: 'Контроль доступа',
      },
      {
        id: 'dept-it-2',
        blockId: 'dept-it',
        text_en: 'Encryption',
        text_es: 'Cifrado',
        text_ru: 'Шифрование',
      },
      {
        id: 'dept-it-3',
        blockId: 'dept-it',
        text_en: 'Network security measures',
        text_es: 'Medidas de seguridad de red',
        text_ru: 'Сетевые меры безопасности',
      },
      {
        id: 'dept-it-4',
        blockId: 'dept-it',
        text_en: 'Logging',
        text_es: 'Registro de eventos',
        text_ru: 'Логирование',
      },
    ],
  },
  {
    id: 'dept-security',
    name_en: 'Security / CISO / ISO Department',
    name_es: 'Departamento de Seguridad / CISO / ISO',
    name_ru: 'Security / CISO / ISO подразделение',
    questions: [
      {
        id: 'dept-sec-1',
        blockId: 'dept-security',
        text_en: 'Technical security measures',
        text_es: 'Medidas técnicas de seguridad',
        text_ru: 'Технические меры безопасности',
      },
      {
        id: 'dept-sec-2',
        blockId: 'dept-security',
        text_en: 'Incident management',
        text_es: 'Gestión de incidentes',
        text_ru: 'Управление инцидентами',
      },
      {
        id: 'dept-sec-3',
        blockId: 'dept-security',
        text_en: 'Risk management',
        text_es: 'Gestión de riesgos',
        text_ru: 'Риск-менеджмент',
      },
    ],
  },
  {
    id: 'dept-legal',
    name_en: 'Legal Department',
    name_es: 'Departamento Legal',
    name_ru: 'Legal подразделение',
    questions: [
      {
        id: 'dept-legal-1',
        blockId: 'dept-legal',
        text_en: 'DPA (Data Processing Agreements)',
        text_es: 'DPA (Acuerdos de Procesamiento de Datos)',
        text_ru: 'DPA',
      },
      {
        id: 'dept-legal-2',
        blockId: 'dept-legal',
        text_en: 'SCC (Standard Contractual Clauses)',
        text_es: 'SCC (Cláusulas Contractuales Estándar)',
        text_ru: 'SCC',
      },
      {
        id: 'dept-legal-3',
        blockId: 'dept-legal',
        text_en: 'Legal grounds',
        text_es: 'Fundamentos legales',
        text_ru: 'Правовые основания',
      },
      {
        id: 'dept-legal-4',
        blockId: 'dept-legal',
        text_en: 'Contract audit',
        text_es: 'Auditoría de contratos',
        text_ru: 'Аудит договоров',
      },
    ],
  },
  {
    id: 'dept-hr',
    name_en: 'HR Department',
    name_es: 'Departamento de Recursos Humanos',
    name_ru: 'HR подразделение',
    questions: [
      {
        id: 'dept-hr-1',
        blockId: 'dept-hr',
        text_en: 'Employee data management',
        text_es: 'Gestión de datos de empleados',
        text_ru: 'Данные сотрудников',
      },
      {
        id: 'dept-hr-2',
        blockId: 'dept-hr',
        text_en: 'Onboarding/offboarding processes',
        text_es: 'Procesos de incorporación/salida',
        text_ru: 'Процессы onboarding/offboarding',
      },
    ],
  },
  {
    id: 'dept-marketing',
    name_en: 'Marketing Department',
    name_es: 'Departamento de Marketing',
    name_ru: 'Marketing подразделение',
    questions: [
      {
        id: 'dept-marketing-1',
        blockId: 'dept-marketing',
        text_en: 'Consent management',
        text_es: 'Gestión de consentimiento',
        text_ru: 'Согласия',
      },
      {
        id: 'dept-marketing-2',
        blockId: 'dept-marketing',
        text_en: 'Newsletter management',
        text_es: 'Gestión de boletines',
        text_ru: 'Рассылки',
      },
      {
        id: 'dept-marketing-3',
        blockId: 'dept-marketing',
        text_en: 'Cookie banner management',
        text_es: 'Gestión de banner de cookies',
        text_ru: 'Cookie-баннер',
      },
    ],
  },
  {
    id: 'dept-support',
    name_en: 'Customer Support Department',
    name_es: 'Departamento de Atención al Cliente',
    name_ru: 'Customer Support подразделение',
    questions: [
      {
        id: 'dept-support-1',
        blockId: 'dept-support',
        text_en: 'Data subject request processing',
        text_es: 'Procesamiento de solicitudes de sujetos de datos',
        text_ru: 'Обработка запросов субъектов данных',
      },
    ],
  },
  {
    id: 'dept-procurement',
    name_en: 'Procurement / Vendor Management Department',
    name_es: 'Departamento de Compras / Gestión de Proveedores',
    name_ru: 'Procurement / Vendor Management подразделение',
    questions: [
      {
        id: 'dept-proc-1',
        blockId: 'dept-procurement',
        text_en: 'Supplier due diligence',
        text_es: 'Diligencia debida de proveedores',
        text_ru: 'Due diligence поставщиков',
      },
      {
        id: 'dept-proc-2',
        blockId: 'dept-procurement',
        text_en: 'DPA management',
        text_es: 'Gestión de DPA',
        text_ru: 'DPA',
      },
      {
        id: 'dept-proc-3',
        blockId: 'dept-procurement',
        text_en: 'Data transfer management',
        text_es: 'Gestión de transferencia de datos',
        text_ru: 'Трансфер данных',
      },
    ],
  },
  {
    id: 'dept-management',
    name_en: 'Company Management',
    name_es: 'Dirección de la Empresa',
    name_ru: 'Руководство компании',
    questions: [
      {
        id: 'dept-mgmt-1',
        blockId: 'dept-management',
        text_en: 'GDPR policy approval',
        text_es: 'Aprobación de políticas GDPR',
        text_ru: 'Утверждает политику GDPR',
      },
      {
        id: 'dept-mgmt-2',
        blockId: 'dept-management',
        text_en: 'DPO appointment',
        text_es: 'Designación de DPO',
        text_ru: 'Назначает DPO',
      },
      {
        id: 'dept-mgmt-3',
        blockId: 'dept-management',
        text_en: 'Resource provision',
        text_es: 'Provisión de recursos',
        text_ru: 'Обеспечивает ресурсы',
      },
    ],
  },
];

export const GDPR_QUESTIONNAIRES = {
  SELF_ASSESSMENT: GDPR_SELF_ASSESSMENT_BLOCKS,
  DOCUMENTS: GDPR_DOCUMENTS_BLOCKS,
  PROCESSES: GDPR_PROCESSES_BLOCKS,
  ROLES: GDPR_ROLES_BLOCKS,
};

